export const groupedMap = {
	OXXO: {
		logo: "OXXO",
		items: ["MonetixOxxo", "BetterBroOXXO", "UnlimitOXXO"],
		name: "OXXO",
	},
	SPEI: {
		logo: "SPEI",
		items: ["Spei", "MonetixSpei", "BetterBroSPEI", "UnlimitSPEI", "APaySPEI", "NuveiSpei"],
		name: "SPEI",
	},
	CODI: {
		logo: "CODI",
		items: ["MonetixCoDi", "UnlimitCodi"],
		name: "CODI",
	},
	BankCard: {
		logo: "BankCard",
		items: [
			"MonetixCard",
			"SkrillCreditCard",
			"UnlimitBankCard",
			"NuveiCreditCard",
			"TrezuzCreditCard",
		],
		name: "Credit Card",
	},
	Crypto: {
		logo: "Crypto",
		items: [
			"EtoroCryptopayment-BTC",
			"EtoroCryptopayment-ETH",
			"EtoroCryptopayment-TRX",
			"EtoroCryptopayment-USDT",
		],
		name: "Cryptocurrency",
	},
	MarsCrypto: {
		logo: "MarsCrypto",
		items: [
			"MarsCryptopaymentBTC",
			"MarsCryptopaymentETH",
			"MarsCryptopaymentTRON",
			"MarsCryptopaymentUSDT",
		],
		name: "Cryptocurrency",
	},
	GannarCrypto: {
		logo: "GannarCrypto",
		items: [
			"EtoroCryptopayment-BTC",
			"EtoroCryptopayment-ETH",
			"EtoroCryptopayment-TRX",
			"EtoroCryptopayment-USDT",
		],
		name: "Cryptocurrency",
	},
	GannarBankTransfer: {
		logo: "GannarBankTransfer",
		items: [
			"MonetixWebpayChile",
			"MonetixMexicoBankTransfer",
			"BetterBroArgentinaTransferencia",
			"BetterBroArgentinaMercadoPago",
			"BetterBroArgentinaNaranjaX",
			"BetterBroArgentinaMODO",
			"BetterBroArgentinaBNA",
			"BetterBroVenezuelaPagoMovilHPP",
			"BetterBroChileKhipuHPP",
			"BetterBroChileMachHPP",
			"BetterBroChileBancoEstadoBankTransfer",
			"BetterBroChileBancodeChileBankTransfer",
			"BetterBroChileBancoSantanderBankTransfer",
			"BetterBroChileBankTransfer",
			"BetterBroChileWebPay",
			"BetterBroEcuadorBankTransferHPP",
		],
		name: "Bank Transfer",
	},
};

export const findGroupByPaymentMethod = (paymentMethod) => {
	if (window.TENANT.includes("mars") && paymentMethod?.startsWith("EtoroCryptopayment")) {
		return "MarsCrypto";
	}

	if (window.TENANT === "gannar") {
		if (paymentMethod?.startsWith("EtoroCryptopayment")) {
			return "GannarCrypto";
		}
		if (groupedMap.GannarBankTransfer.items.includes(paymentMethod)) {
			return "GannarBankTransfer";
		}
	}

	return Object.keys(groupedMap).find((key) => groupedMap[key].items.includes(paymentMethod));
};
